import React, { useEffect, useState, useMemo } from 'react';
import { View } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import { fetchRoomRankerData } from '../actions/fetchRoomRankerData';
import { toggleSorting } from '../../FeedBackList/actions/sortingActions';
import MultiFeatureCard from '../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import RoomRankerTable from './RoomRankerTable';
import { parseFilters } from '../../Filters/utils/fetchData';

import get from 'lodash/get';

const RoomRankerTableWrapper = ({ itemData, reduxData, applied_filter_values, applied_filters }) => {
  const dispatch = useDispatch();

  const timeperiodLabel = get(applied_filters, 'timePeriod[0].fullLabel', ' ');
  const benchmarkLabel = get(applied_filters, 'benchmark[0].fullLabel', ' ');

  const sortReducer = useSelector(state => state.sortReducer);
  const isFetchingData = useSelector(state => get(state, 'roomRanker.isFetchingData', false));

  const [sortingInProgress, setSortingInProgress] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const page_size = get(itemData, 'page_size', 10);
  const widgetId = get(itemData, 'widgetId', '');

  const { filters, benchmark } = useMemo(() => {
    try {
      return parseFilters(applied_filter_values);
    } catch (e) {
      return { filters: {}, benchmark: {} };
    }
  }, [applied_filter_values]);

  useEffect(() => {
    if (widgetId && Object.keys(filters || {}).length > 0) {
      dispatch(
        fetchRoomRankerData({
          widgetId,
          filters,
          benchmark,
          sort: {
            field_name: sortReducer.field_name,
            direction: sortReducer.direction
          },
          offset: (currentPage - 1) * page_size,
          limit: page_size
        })
      );
    }
  }, [filters,benchmark,sortReducer.field_name,sortReducer.direction,currentPage]);

  useEffect(() => {
    if (sortingInProgress && !isFetchingData) {
      setSortingInProgress(false);
    }
  }, [isFetchingData, sortingInProgress]);

  const handleOnSortClick = key => {
    setSortingInProgress(true);
    dispatch(toggleSorting(key));
    setCurrentPage(1);
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const rawData = get(reduxData, 'tableData', []);

  const renderContent = () => {
    return (
      <RoomRankerTable
        itemData={itemData}
        reduxData={reduxData}
        sortReducer={sortReducer}
        isFetchingData={isFetchingData}
        sortingInProgress={sortingInProgress}
        currentPage={currentPage}
        page_size={page_size}
        rawData={rawData}
        handleOnSortClick={handleOnSortClick}
        handlePageChange={handlePageChange}
      />
    );
  };

  return (
    <View>
      <MultiFeatureCard
        title={get(itemData, 'title', '')}
        subTitle={timeperiodLabel + ' | Benchmark: ' + benchmarkLabel}
        loading={isFetchingData}
        isNoData={!isFetchingData && get(rawData, 'length', 0) === 0}
        renderContent={renderContent}
      />
    </View>
  );
};

export default RoomRankerTableWrapper;